import React, { useEffect, useState } from 'react';
import DialogBox from '@techsoftware/happay-widgets/DialogBox';
import Button from '@techsoftware/happay-widgets/Button';
import RescheduleDatePicker from './rescheduleDatepicker';
import history from '../../../utils/history';

export default function ReschedulePayment(props) {
  const [date, setDate] = useState('');
  const {
    onClose,
    onSubmit,
    open = false,
    rescheduleSuccess = false,
    rescheduleCancelSuccess,
  } = props;

  const onDateChange = (event, value) => {
    setDate(value);
  };

  const onCloseDialog = () => {
    setDate('');
    onClose();
  };

  useEffect(() => {
    if (rescheduleSuccess) {
      setDate('');
      history.goBack();
      setTimeout(() => {
        rescheduleCancelSuccess('reschedule', false);
      }, 500);
    }
  }, [props.rescheduleSuccess]);

  const onSubmitClick = () => {
    onSubmit(date);
  };

  return (
    <DialogBox
      open={open}
      id="reschedule-payment"
      onClose={onCloseDialog}
      title={rescheduleSuccess ? '' : 'Reschedule Payment Date'}
      actionBorder
      crossIcon
      width="500px"
      dialogTitleContainerStyle={{ paddingBottom: '16px', fontWeight: '600' }}
      bodyStyle={{ overflow: 'visible' }}
      actionStyle={{ zIndex: 0 }}
      actions={
        <div>
          {rescheduleSuccess ? (
            <></>
          ) : (
            <Button
              type="button"
              text="Cancel"
              variant="secondary"
              className="margin-r-20"
              onClick={onCloseDialog}
            />
          )}
          <Button
            type="button"
            disabled={!date}
            text="Confirm"
            onClick={onSubmitClick}
          />
        </div>
      }
    >
      <div className="padding-lr-30">
        <div>Please reschedule the payment to a new date below.</div>
        <RescheduleDatePicker
          onChange={onDateChange}
          date={date}
          style={{ margin: '30px 0' }}
          containerStyle={{ width: '300px' }}
        />
      </div>
    </DialogBox>
  );
}
